<template>
  <ul class="c-nav c-nav--vertical">
    <li>
      <label
        :class="{
          'is-active' : bathroomState.length === 0,
        }"
        for="bathrooms-all"
        class="c-btn c-btn--invisible c-btn--vert-center"
      >
        <input
          id="bathrooms-all"
          v-model="bathroomState"
          :value="[]"
          type="radio"
          name="bathrooms"
          class="screen-reader-text"
        >
        <Toggle
          :isSelected="bathroomState.length === 0"
          class="c-btn__icon c-btn__icon--alignment"
        />
        Alle
      </label>
    </li>
    <li
      v-for="bathroom in bathrooms"
      :key="bathroom.id"
    >
      <label
        :for="'bathrooms-' + bathroom.id"
        :class="{
          'is-active' : bathroomState.includes(bathroom.name),
        }"
        class="c-btn c-btn--invisible c-btn--vert-center"
      >
        <input
          :id="'bathrooms-' + bathroom.id"
          v-model="bathroomState"
          :value="bathroom.name"
          type="checkbox"
          name="bathrooms"
          class="screen-reader-text"
        >
        <Toggle
          :isSelected="bathroomState.includes(bathroom.name) === true"
          class="c-btn__icon c-btn__icon--alignment"
        />
        {{ bathroom.name }} bad
      </label>
    </li>
  </ul>
</template>

<script>
import Bathroom from '@/models/Bathroom';
import Residence from '@/models/Residence';

import Toggle from '@/components/Toggle.vue';


export default {
  name: 'SelectBathrooms',
  components: {
    Toggle,
  },
  computed: {
    bathrooms() {
      return Bathroom.all();
    },
    bathroomState: {
      get() {
        return this.$store.state.entities.residences.bathrooms;
      },
      set(bathrooms) {
        Residence.commit(state => {
          state.bathrooms = bathrooms;
        });
      },
    },
  },
};
</script>